// extracted by mini-css-extract-plugin
export default {"edit":"edit-oBBq"};